import { action, computed, makeObservable, observable } from 'mobx'

import { IRemoteTileset } from '~/client/graph/types.generated'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'

import {
  DELETE_REMOTE_TILESET,
  UPLOAD_REMOTE_TILESETS,
} from '../EventStore/eventConstants'

export default class RemoteTilesetsStore {
  @observable public isDataReceived: boolean = false

  public constructor(private readonly eventsStore: EventsStore) {
    makeObservable(this)
  }

  @computed
  public get list(): IRemoteTileset[] {
    return Array.from(this.byId.values())
  }

  public get byId(): Map<string, IRemoteTileset> {
    const { remoteTilesets } = this.eventsStore.appState
    return remoteTilesets
  }

  @action.bound
  public clearList() {
    this.byId.clear()
  }

  @action.bound
  public setList(list: IRemoteTileset[]) {
    this.clearList()
    list.forEach(dto => {
      this.byId.set(dto?.id, dto)
    })
    this.isDataReceived = true
  }

  @action.bound
  public updateRemoteTileset(updated: IRemoteTileset) {
    if (updated?.id) {
      this.byId.set(updated.id, updated)
    }
  }

  @action.bound
  public receiveOne(id: string, item: IRemoteTileset | null) {
    if (item) {
      this.byId.set(id, item)
    } else {
      this.byId.delete(id)
    }
  }

  @action.bound
  public removeRemoteTileset(id: string, callbackFn?: () => void) {
    if (!this.byId.has(id)) {
      return
    }

    this.byId.delete(id)

    this.eventsStore.dispatch(DELETE_REMOTE_TILESET, id, callbackFn)
  }

  @action.bound
  public async uploadRemoteTileset(
    remoteTileset: IRemoteTileset,
    callbackFn?: () => void,
  ) {
    this.eventsStore.dispatch(UPLOAD_REMOTE_TILESETS, remoteTileset, callbackFn)
  }
}
